<template>
    <div class="selectTable">
      <div class="brand border">
        <a :href="vendorData.all_sg_link" target="_blank" @click="countAd(4213)">
            <img :src="vendorData.logo" />
        </a>
        <div class="info">
          <strong>
            <a :href="vendorData.all_sg_link" target="_blank" @click="countAd(4214)">{{vendorData.name}}</a>
          </strong>
          <div class="doc" v-if="vendorData.desc_link">{{vendorData.desc}}<a :href="vendorData.desc_link" target="_blank">详细 &gt;&gt;</a>
          </div>
        </div>
      </div>
      <div class="price">
        <div class="w70" id="hotSerial">热门车系：</div>
        <div class="w540 ks_car">
          <ul class="rmcx" v-for="(vendor,index) in vendorlist" :key="index">
            <li class="ml20" v-for="(item,i) in vendor" :key="i">
              <a class="car-img-link" :href="item.link" target="_blank" :title="item.name"><img class="car-img" alt="" :src="getImgUrl(item)"></a>
              <p class="p1">
                <a :href="item.link" target="_blank" :title="item.name"  @click="countAd(4215)">{{item.name}}</a>
              </p>
              <p class="p2">
                <a :href="item.price_link" target="_blank"  @click="countAd(4216)">{{item.price}}</a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <a :href="vendorData.all_sg_link" target="_blank" class="more"  @click="countAd(4217)">查看全部车系</a>
    </div>
</template>

<script>
export default {
    name: 'VendorHead',
    props: {
        vendorData: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        vendorlist() {
            let arr = []
            for(let i=0; i<Math.ceil(this.vendorData.serial_groups.length/4); i++){
                let start = i*4;
                let end = start+4;
                arr.push(this.vendorData.serial_groups.slice(start,end));
            }
            return arr
        }
    },
    methods: {
        // 获取图片链接
        getImgUrl(item) {
            return item.touPic || item.baiPic || item.photo || 'https://www1.pcauto.com.cn/2022/kuaisou/images/car-img-default_200x150.png'
        }
    }
};
</script>

<style lang="scss" scoped>
.selectTable {
    border: 1px solid #d7d7d7;
    background: #fcfcfc;
    color: #333333;
    padding-bottom: 1px;
    margin-bottom: 25px;
    a {
        color: #000;
        text-decoration: none;
        outline: none;
    }
    .border {
        border-bottom: #eeeeee 1px solid;
    } 
    .brand {
        height: 94px;
        position: relative;
        img {
            position: relative;
            top: 15px;
            left: 15px;
            height: 64px;
            width: 64px;            
        }
        .info {
            width: 510px;
            position: absolute;
            top: 10px;
            left: 100px;    
            strong {
                font-size: 16px;
                line-height: 28px;   
                a {
                    color: #225599;                    
                }             
            } 
            .doc {
                line-height: 20px;
                height: 40px;
                overflow: hidden; 
                a {
                    color: #225599;                    
                }              
            }       
        }
    }  
    .price  {
        display: flex;
        align-items: flex-start;
        margin-top: 12px;
        .w70 {
            width: 70px;
            margin-top: 8px;
            text-align: center;
        }
        .ks_car {
            flex: 1;
            ul {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                border-bottom: 1px dashed #e3e3e3;
                margin-right: 10px;
                padding: 5px 0;
                &:last-of-type {
                    border-bottom:none;
                }
                li {
                    min-width: 100px;
                    margin-right: 35px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    p {
                        display: inline;
                        line-height: 17px;
                        overflow: hidden;
                        word-break: break-all;
                        word-wrap: break-word;
                        text-align: center; 
                    }
                    .p1 {
                        a {
                            color: #225599;
                        }
                    }
                    .p2 {
                        a {
                            color: #cc0000;
                            font-weight: 500;
                        }
                    }
                    .car-img-link{
                        display: block;
                    }
                    .car-img{
                        width: 100px;
                        height: 75px;
                        object-fit: contain;
                    }
                }
            }
        }   
    }
    .more {
        display: block;
        text-align: center;
        background: #f4f4f4;
        width: 616px;
        height: 26px;
        line-height: 26px;
        margin: 0 auto;
        color: #333333;        
    }
}
</style>
